import { Component } from '@angular/core';
import { ApiImpact, ApiUser, ImpactsApi } from '@tytapp/api';
import { AppConfig, PageComponent, PagedArray, PageService } from '@tytapp/common';
import { COMMUNITY_C2A, DONATION_C2A, MEMBERSHIP_C2A } from '@tytapp/common/c2a';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'tyt-company-impact-page',
  templateUrl: './company-impact-page.component.html',
  styleUrls: ['./company-impact-page.component.scss']
})
export class CompanyImpactPageComponent extends PageComponent {

  impacts: PagedArray<ApiImpact>;
  impactsFirstSection: ApiImpact[];
  impactsSecondSection: ApiImpact[];

  user : ApiUser;

  constructor(
    pageService: PageService,
    private impactsApi: ImpactsApi,
    private userService : UserService,
    private appConfig: AppConfig
  ) {
    super(pageService);
  }

  get purchaseUrl() {
    return this.appConfig.purchaseUrl;
  }

  otcUrl : string;

  offerSetID: string;

  get showEmbeddedOffers(): boolean {
    return this.offerSetID && (!this.user || !this.user.membership || !this.user.membership.active);
  };

  async init() {
    this.subscribe(this.impactsApi.getImpacts(), (data) => {
      this.impacts = data;
      if(this.impacts.length > 2) {
        this.impactsFirstSection = this.impacts.slice(0, 2);
        this.impactsSecondSection = this.impacts.slice(2);
      } else {
        this.impactsFirstSection = this.impacts.slice();
        this.impactsSecondSection = [];
      }
    });

    this.subscribe(this.userService.userChanged, user => this.user = user);

    await this.appConfig.appStatusReady;

    if(this.appConfig.appStatus && this.appConfig.appStatus.settings && this.appConfig.appStatus.settings['impacts_page_offer_set']) {
      this.offerSetID = this.appConfig.appStatus.settings['impacts_page_offer_set'];
    }

    if (await this.appConfig.featureEnabled('apps.web.enable_otc_c2a')) {
      this.otcUrl = `${this.appConfig.accountsUrl}/settings/one-time-contribution`;
    } else {
      this.otcUrl = 'https://tyt.com/go';
    }
  }

  get c2a() {
    MEMBERSHIP_C2A.url = this.purchaseUrl;
    DONATION_C2A.url = this.otcUrl;

    if (!this.user)
      return COMMUNITY_C2A;
    if (!this.user.membership || !this.user.membership.active)
      return MEMBERSHIP_C2A;
    return DONATION_C2A;
  }

}
